export const enum zIndex {
  svg = -1,
  bar = 1,
  icon = 2,
  image = 10,
  text = 100,
  eodBar = 2
}
